import { blue, purple, white } from 'modules/colors';
import media from 'modules/media';
import { fonts, spacing } from 'modules/metrics';
import ImageNext from 'next/image';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: ${(props) => (props.size === 'xl' ? 500 : 250)}px;
  position: relative;
`;

export const BigLine = styled.hr`
  height: ${spacing.md}px;
  border: 0;
  margin: 0;
`;

export const TopLine = styled(BigLine)`
  background-color: ${blue};
`;

export const BottomLine = styled(BigLine)`
  background-color: ${purple};
`;

export const Cover = styled.div`
  position: absolute;
  background-color: rgb(25 66 126);
  opacity: 0.6;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const Image = styled(ImageNext)`
  z-index: 0;
`;

export const Content = styled.div`
  max-width: 1403px;
  margin: 0 auto;
  height: 100%;
`;

export const Info = styled.div`
  position: absolute;
  color: ${white};
  top: ${(props) => (props.size === 'xl' ? 185 : 87)}px;
  z-index: 1;

  ${media.custom(1440)} {
    padding: 0 ${spacing.xl}px;
  }
`;

export const HalfleftLogo = styled.img`
  position: absolute;
  top: ${(props) => (props.size === 'xl' ? 144 : 75)}px;
  ${(props) => props.size === 'md' && `width:53px;`}
  opacity: 0.5;
  z-index: 1;

  ${media.phone} {
    display: none;
  }
`;

export const HalfRightLogo = styled.img`
  position: absolute;
  right: 0px;
  top: ${(props) => (props.size === 'xl' ? 24 : 13)}px;
  ${(props) => props.size === 'md' && `width:128px;`}
  opacity: 0.5;
  z-index: 1;

  ${media.phone} {
    display: none;
  }
`;

export const TitleWrapper = styled.div`
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  display: flex;
`;

export const TitleText = styled.h1`
  font-size: ${fonts.xxl}px;
  color: ${white};

  ${media.phone} {
    font-size: ${fonts.xl}px;
  }
`;

export const Dash = styled.hr`
  width: 20px;
  background-color: ${blue};
  height: 3px;
  border: 0;
  align-self: flex-end;
  margin: 0 0 0 ${spacing.md}px;
  ${(props) => props.noDash && 'display:none;'}

  ${media.phone} {
    display: none;
  }
`;

export const WhiteLine = styled.hr`
  background-color: ${white};
  height: 2px;
  border: 0;
  margin-top: ${spacing.md}px;
  width: 100%;
`;

export const Text = styled.p`
  padding: ${spacing.md}px 0;
  font-weight: 500;
  max-width: 450px;
  line-height: 18px;

  ${media.tablet} {
    width: 100%;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: ${spacing.xl}px;

  > button {
    margin-right: ${spacing.lg}px;
  }

  ${media.phone} {
    align-items: flex-start;
    flex-direction: column;

    > button {
      margin-right: 0;

      margin-bottom: ${spacing.lg}px;
      :last-child {
        margin-bottom: 0;
      }
    }
  }
`;
